import {
  useCampaignCreateMutation as useApolloCampaignCreateMutation,
  useCampaignUpdateMutation as useApolloCampaignUpdateMutation,
  useCampaignDeleteMutation as useApolloCampaignDeleteMutation,
  CampaignCreateMutationOptions,
  CampaignUpdateMutationOptions,
  CampaignDeleteMutationOptions,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useCampaignCreateMutation = (baseOptions: CampaignCreateMutationOptions) =>
  useMutation(useApolloCampaignCreateMutation, baseOptions);

export const useCampaignUpdateMutation = (baseOptions: CampaignUpdateMutationOptions) =>
  useMutation(useApolloCampaignUpdateMutation, baseOptions);

export const useCampaignDeleteMutation = (baseOptions?: CampaignDeleteMutationOptions) =>
  useMutation(useApolloCampaignDeleteMutation, baseOptions);
